/**
 *
 * FlashCardLanding
 *
 */

import { mapGetters } from 'vuex';

import Swal from 'sweetalert2';

export const FlashCardFavoriteMixin = {
  name: 'FlashCardFavoriteMixin',

  computed: {
    ...mapGetters('FlashCard/FlashCardLanding', {
      mg_flashCardList: 'flashCardList',
    }),
  },

  methods: {
    gotoFavorite() {
      if (this.mg_flashCardList.countFavoriteCardByCourse) {
        this.$router.push(`/flash-card-favorite/${this.$route.params.courseId}`);
      } else {
        Swal.fire({
          width: '400px',
          backdrop: false,
          type: 'warning',
          icon: 'warning',
          title: '没有收藏的卡片！',
          showConfirmButton: false,
          timer: 4000,
        });
      }
    },
  },
};
